<div class="flex flex-col h-full">
  <div class="flex py-2 justify-between">
    <div class="flex w-1/5">
      <elcia-search [control]="searchControl"/>
    </div>
    <div class="flex gap-2">
      <elcia-button (onClick)="showForm()" [label]="'action.add-feature' | translate" [icon]="'plus'"/>
    </div>
  </div>

  <div class="flex-1 overflow-hidden">
    @if (isLoading()) {
      <elcia-loader/>
    } @else {
      <elcia-feature-grid
        (onDelete)="onFeatureDelete($event)"
        (featureSelected)="onFeatureSelect($event)"
        [features]="features()"/>
    }
  </div>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    (onDelete)="deleteFeature()"
    [isActionLoading]="isFormSaving()"
    [mustDisplayDeleteButton]="isEditMode()"
    [size]="'medium'"
    [title]="'entity.feature' | translate">

    @if (isLoadingSelected()) {
      <elcia-loader/>
    } @else {
      <elcia-feature-form
        (onSubmit)="submit($event)"
        [initialValue]="store.selectedFeature() ?? undefined"
      />
    }
  </elcia-dialog>
}
